import { ColumnConfigReportComboApi } from "./types";

const getBackgroundColor = (percent: number): string => {
	if (percent === 0) {
		return "#f8f9fa"; // Bootstrap's `bg-light`
	}

	const absPercent = Math.min(Math.abs(percent), 100); // Cap at 100%

	if (percent > 0) {
		// Green from light to dark
		return `rgba(40, 167, 69, ${absPercent / 100})`; // Bootstrap `success` green
	}
	// Red from light to dark
	return `rgba(220, 53, 69, ${absPercent / 100})`; // Bootstrap `danger` red
};
const getTextColor = (percent: number): string => {
	const opacity = Math.min(Math.abs(percent), 100) / 100;
	return opacity < 0.4 ? "#000" : "#fff"; // Black text for light backgrounds
};

export class StylesReportComboUtils {
	static getColumneStyles(config: ColumnConfigReportComboApi, value: any): any {
		if (!config.styles?.percent_color) return {};
		if (value === Infinity) value = 0;
		const backgroundColor = getBackgroundColor(value);
		const textColor = getTextColor(value);
		const styles = {
			backgroundColor,
			color: textColor,
			// verticalAlign: "middle",
			padding: "0.5rem",
		};
		return styles;
	}
}
